import React from 'react'
import ImageGallery from 'react-image-gallery'

import { PondImage } from '@/components/_base/PondImage'
import { useDevice, useViewport } from '@/context/Device'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ListingCate } from '@/page-commons/listingBySlug'
import { handleClickNavigate } from '@/utils/tracking/eventsHandlers'

import { carouselButton } from '../../style.css'

type Props = {
  images: ListingCate['photos']
  onIndexChange: (index: number) => void
  startIndex: number
}

export const ModalGallery: React.FC<Props> = ({ images, onIndexChange, startIndex }) => {
  const device = useDevice()
  const { width: innerWidth } = useViewport()
  const modalType = 'show-gallery'

  const imageMaxWidth = 1186
  const imageWidth = Math.min(imageMaxWidth, innerWidth)

  const imageMaxHeight169 = (imageMaxWidth / 16) * 9
  const imageHeight169 = device === 'desktop' ? ((innerWidth * 0.8) / 16) * 9 : (innerWidth / 16) * 9

  const imageModalGalleryHeight = innerWidth > imageMaxWidth ? imageMaxHeight169 : imageHeight169

  const handlerNavArrowsClick = (onClick) => (event) => {
    event.preventDefault()
    event.stopPropagation()
    onClick()
  }

  return (
    <div className={sprinkles({ height: '100%', paddingY: { tablet: 'l' } })}>
      <ImageGallery
        items={images}
        renderItem={(photo: ListingCate['photos'][number]) => {
          return (
            <div style={{ height: imageModalGalleryHeight }}>
              <PondImage
                imageOptions={{
                  ar: '16:9',
                  fit: 'crop',
                  w: imageWidth,
                }}
                layout="fill"
                src={photo.url}
              />
            </div>
          )
        }}
        renderLeftNav={(onClick) => {
          return device !== 'mobile' ? (
            <button className={carouselButton({ prev: true })} onClick={handlerNavArrowsClick(onClick)} />
          ) : null
        }}
        renderRightNav={(onClick) => {
          return device !== 'mobile' ? (
            <button
              className={carouselButton({ next: true })}
              data-testid="image-gallery-button-next"
              onClick={handlerNavArrowsClick(onClick)}
            />
          ) : null
        }}
        showFullscreenButton={false}
        showIndex={true}
        showPlayButton={false}
        showThumbnails={false}
        slideDuration={450}
        startIndex={startIndex}
        stopPropagation={true}
        onBeforeSlide={onIndexChange}
        onSlide={() => {
          handleClickNavigate('ListingDetailGalleryModal')
        }}
      />
    </div>
  )
}
